var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 12.357 12.5 13.5355 11.7678 14.2677C11.0355 15 9.85703 15 7.5 15C5.14298 15 3.96446 15 3.23224 14.2677C2.5 13.5355 2.5 12.357 2.5 10C2.5 7.64298 2.5 6.46446 3.23224 5.73224C3.96446 5 5.14298 5 7.5 5C9.85703 5 11.0355 5 11.7678 5.73224C12.5 6.46446 12.5 7.64298 12.5 10Z",
    fill: "#FF8D41",
    stroke: "#FF8D41",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.75V14.3526C12.5 19.3184 9.35536 23.5296 5 25",
    stroke: "#FF8D41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10C27.5 12.357 27.5 13.5355 26.7677 14.2677C26.0355 15 24.857 15 22.5 15C20.143 15 18.9645 15 18.2323 14.2677C17.5 13.5355 17.5 12.357 17.5 10C17.5 7.64298 17.5 6.46446 18.2323 5.73224C18.9645 5 20.143 5 22.5 5C24.857 5 26.0355 5 26.7677 5.73224C27.5 6.46446 27.5 7.64298 27.5 10Z",
    fill: "#FF8D41",
    stroke: "#FF8D41",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 8.75V14.3526C27.5 19.3184 24.3554 23.5296 20 25",
    stroke: "#FF8D41",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteDown);
export default __webpack_public_path__ + "static/media/quote-down.f0e6e86d6974d2fb4add45f845972f83.svg";
export { ForwardRef as ReactComponent };